import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './teamsProjectCalendar.html?raw';

import topic from 'dojo/topic';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { ExtraHelpers } from "../../../../more/Helpers"; "../../../../more/Helpers";

import MainPropertiesV2 from '../../../WebCalendar_TS/MainProperties/MainPropertiesV2';

class teamsProjectCalendar extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private calendarContainerNode:HTMLDivElement;
    private weekSelectorContainer:HTMLDivElement;
    private teamsProperties: MdsLax<InstanceType<typeof MainPropertiesV2>>;


    postCreate(): void {
        this.postCreatAsync();
    }
    private async postCreatAsync(){
        let jsDependencies =  Promise.all([
            ExtraHelpers.sideLoadResource(window.appRoot + "lib/Syncfusion/material.min.css", 'css'),
            ExtraHelpers.sideLoadResource(window.appRoot + "lib/Syncfusion/ej2.min.js", 'js'),
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/WebCalendar_style.css", 'css')
        ]);

        //ist sauberer als topbar ganz einblenden und dann teile ausblenden
        let originalGlobalSpace = document.getElementById("mainMenuGlobalSpace");
        if (typeof originalGlobalSpace != 'undefined')
        {
            originalGlobalSpace.setAttribute("id", "mainMenuGlobalSpace__ORIGINAL");
        }
        this.weekSelectorContainer.id = "mainMenuGlobalSpace";


        await jsDependencies; //auf sf dependencies warten

        let tabId: string = window.msTeamsSimpleApi?.metadata?.context?.page?.id ?? "dev_tab";
        this.teamsProperties = new MainPropertiesV2();
        this.teamsProperties.setMainConfig({
            userProperties:{
                customFunctionName:"Webtool_API_Webcalendar__GetUserProperties_TeamsIntegration",
                requestParams:[{
                    name:"jsonData",
                    value: JSON.stringify({
                        teamsTabId: tabId,
                        teamID: window.msTeamsSimpleApi?.metadata?.context?.team?.groupId ?? null,
                        channelID: window.msTeamsSimpleApi?.metadata?.context?.channel?.id ?? null
                    })
                }],
            },
            filterData:{
                customFunctionName: "Webtool_API_Webcalendar__GetFilterData_TeamsIntegration",
                additionArgs:{
                    teamsIntegration_tabId: tabId,
                    teamID: window.msTeamsSimpleApi?.metadata?.context?.team?.groupId ?? null,
                    channelID: window.msTeamsSimpleApi?.metadata?.context?.channel?.id ?? null
                }
            }
        });


        this.calendarContainerNode.appendChild(this.teamsProperties.domNode);
        this.teamsProperties.startup();
        if (typeof window["sessionInfo"]["sessionData"] != 'undefined'){
            topic.publish("/Session/CheckForExistingSession", window.sessionInfo.sessionData);
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(teamsProjectCalendar);
